export default __webpack_public_path__ + "static/media/DisabledCamera2.9fe04d0c.svg";